module.exports = __webpack_public_path__ + "static/media/package.aabcd105.jpg";